module.exports = __webpack_public_path__ + "img/jidy.1d868682.jpg";